import { useSearchspringContext } from 'libs/searchspring/fetchers/provider'
import { useEffect } from 'preact/hooks'
import { useIntersectionObserver } from '@/components/hooks/useIntersectionObserver'

export function useFilterScroll() {
  const { options } = useSearchspringContext()
  const filters = options.get('filters')
  const sorts = options.get('sort')
  const { setNode: setScrollElement, entry: scrollStartElement } = useIntersectionObserver({ threshold: 0.05 })

  useEffect(() => {
    if (scrollStartElement?.isIntersecting === false || scrollStartElement?.boundingClientRect?.top < window.scrollY) {
      const offset = 50
      const scrollToPosition = scrollStartElement?.boundingClientRect?.top - offset
      window.scrollTo({ top: scrollToPosition, behavior: 'instant' })
    }
  }, [filters, sorts])

  return { setScrollElement }
}
